import { units } from '@m/alchemy-theme';
import { StarFilledIcon } from '@m/alchemy-ui/icons/StarFilledIcon';
import styled from 'styled-components';

export const StarsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${units(0.5)};
`;

const Stars = ({ count, size = 12 }: { count: number; size: number }) => (
  <StarsContainer>
    {Array.from({ length: count }, (x, i) => (
      <StarFilledIcon
        key={`star-${i}`}
        size={size}
        aria-label="star"
        palette={count < 4 ? 'expressiveNegative' : 'expressivePositive'}
      />
    ))}
  </StarsContainer>
);

export default Stars;
